export default "__VITE_ASSET__193a0d47__"